import { Modal } from "react-bootstrap";
import React, { useContext, useState, useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import { Link } from "react-router-dom";
import split from "../images/split.png";
import "../styleSheets/home.css";
import network from "../images/network.png";
import reactDom from "react-dom";
import { UserContext } from "../Context/UserContext";
import "bootstrap/dist/css/bootstrap.min.css";

const Home = () => {
  const [showNameModal, setShowNameModal] = useState(false);
  const [name, setName] = useState("");

  // const [profileLoading, setProfileLoading] = useState(true); // 🔵 ADDED
  const [saveLoading, setSaveLoading] = useState(false); // 🔵 ADDED

  // const { getUserProfile, userDetails } = useContext(UserContext);
  const { userDetails, loading, getUserProfile } = useContext(UserContext);

  function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  }

  const subscribeUserToPush = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.log("Permission not granted");
        return;
      }

      const registration = await navigator.serviceWorker.ready;

      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
          "BC7jqc0Hm7sibOxLrIKtorsdCy0gqw_2W2u53RyZqAmd9EQdUPN2Zidae9jnCqScbwsfDiMHF6k8zI1FAsEGfV0",
        ),
      });

      await fetch(`${process.env.REACT_APP_API_URL}/api/push/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(subscription),
      });

      console.log("Push subscribed successfully");
    } catch (err) {
      console.error("Push subscription error:", err);
    }
  };

  useEffect(() => {
    if (userDetails?._id) {
      subscribeUserToPush();
    }
  }, [userDetails?._id]);

  const token = localStorage.getItem("token");
  let myId = "";
  if (token) {
    const decoded = jwtDecode(token);
    myId = decoded.user.id;
  }

  useEffect(() => {
    if (!loading && userDetails) {
      setShowNameModal(!userDetails.name);
    }
  }, [userDetails, loading]);

  const handleSaveName = async () => {
    if (!name.trim()) return;

    try {
      setSaveLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/editUser/${myId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            name: name,
          }),
        },
      );
      await getUserProfile(); // 🔵 ADDED (refresh profile properly)
      setShowNameModal(false);
    } finally {
      setSaveLoading(false);
    }
  };
  if (loading) {
    // 🔵 ADDED
    return (
      // 🔵 ADDED
      <div className="page-loader">
        {" "}
        {/* 🔵 ADDED */}
        <div className="spinner-border text-primary"></div> {/* 🔵 ADDED */}
      </div>
    );
  }

  return (
    <div>
      <div className="main-cont">
        <div className="d-flex justify-content-center align-items-center top-cont">
          <div className="hdng-cont">
            <h2 className="hdng">
              Split food bills.
              <br />
              Track Money. <br /> Stay connected
            </h2>
            <p>
              A simple way for friends to split restaurant bills, track who owes
              what, and discover great food together
            </p>
          </div>
          <div className="top-img-cont">
            <img src={split} className="top-img" />
          </div>
        </div>

        <div className="d-flex flex-row  boxes-row">
          <div className=" boxes">
            <h2>Add a Transaction</h2>
            <p>
              Add who paid, how much and who was involved.we automatically split
              the amount
            </p>
          </div>
          <div className="boxes">
            <h2>Track Owes & Gets</h2>
            <p>
              See clearly who owes you and whom you need to pay.No confusion
            </p>
            <Link to="/addTransaction">
              <button className="start-btn">Get Started</button>
            </Link>
          </div>
          <div className=" boxes">
            <h2>Settle Easily</h2>
            <p>Send payment requests and confirm once paid.</p>
          </div>
        </div>

        <div className="network-row">
          <div>
            <img src={network} className="network-img" />
          </div>
          <div className="network-content">
            <h2>Build Your Food Circle</h2>
            <p>
              Foodies Network lets you connect with your friends, send and
              accept requests, and manage your food circle. Add friends first,
              then easily create shared transactions, split bills, and keep
              everything transparent and simple.
            </p>
          </div>
        </div>

        <div className="org-btn">
          <Link to="/foodiesNetwork">
            <button className="start-btn network-btn">
              Connect With Friends
            </button>
          </Link>
        </div>

        <div className="d-flex justify-content-center end-row">
          <div className="end-cont end-txt-left">
            <h1>Less Confusion. More food. Better friendships</h1>
            <p>
              <i class="fa-regular fa-circle-check mx-2 gtick"></i>No awkward
              money conversations
            </p>
            <p>
              <i class="fa-regular fa-circle-check mx-2 gtick"></i>No messy
              whatsapp notes.
            </p>
            <p>
              <i class="fa-regular fa-circle-check mx-2 gtick"></i>No forgotten
              payments
            </p>
            <p>
              <i class="fa-regular fa-circle-check mx-2 gtick"></i>one place for
              money + friends + food
            </p>
          </div>

          <div className="end-cont end-txt-right">
            <h1>Upcoming features</h1>
            <p>
              <i class="fa-brands fa-gratipay mx-2 icons"></i>Foodies Feed{" "}
              <span>(Upload, Like, Comment, etc)</span>
            </p>
            <p>
              <i class="fa-solid fa-utensils mx-2 icons"></i>Restaurant
              Suggestions by friends{" "}
              <span>(FavoriteDishes, wishlist, Ratings)</span>
            </p>
            <p>
              <i class="fa-solid fa-file-arrow-down mx-2 icons"></i>Download
              Statements (Month-wise, Friend-wise)
            </p>
            <p>
              <i class="fa-solid fa-angles-right mx-2 icons"></i>And Many
              more.....
            </p>
          </div>
        </div>

        <div className="footer">
          <p class="footer-quote">
            Built with 🧡 for food, friends, and fair splits
          </p>
          <p class="footer-author">— Santosh</p>
        </div>
      </div>

      {showNameModal !== null && (
        <Modal
          show={showNameModal}
          backdrop="static"
          keyboard={false}
          centered
          dialogClassName="welcome-modal"
        >
          <Modal.Header className="welcome-header">
            <Modal.Title className="welcome-title">
              New here? We like that 😌
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="welcome-body">
            <p className="welcome-subtext">
              Let’s set up your space in 2 seconds.
            </p>

            <input
              type="text"
              placeholder="What’s your sweet name?"
              className="form-control welcome-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength={25}
            />
          </Modal.Body>

          <Modal.Footer className="welcome-footer">
            <button
              className="welcome-btn"
              disabled={!name.trim() || saveLoading}
              onClick={handleSaveName}
            >
              {saveLoading ? (
                <span className="spinner-border spinner-border-sm text-light"></span>
              ) : (
                "Let’s Begin ✨"
              )}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default Home;
